<template>
  <div class="lessons">
    <h2 class="title is-3 has-text-centered has-text-grey">
      Lessons
    </h2>

    <b-tabs type="is-toggle" position="is-centered" v-model="activeTab">
      <!-- Beginner -->
      <b-tab-item label="Beginner">
        <p class="tab-description">
          Below are some wonderful Introductory Chess Lessons from our friends
          at
          <a href="https://www.esnaj.com">Escuela Nacional de Ajedrez AC</a> -
          The National School of Chess in Mexico.
        </p>
        <VideoGrid :videos="beginner" />
      </b-tab-item>

      <!-- Rookie -->
      <b-tab-item label="Rookie">
        <VideoGrid :videos="rookie" />
      </b-tab-item>

      <!-- Intermediate -->
      <b-tab-item label="Intermediate 🆕">
        <VideoGrid :videos="intermediate" />
      </b-tab-item>

      <!-- Advanced -->
      <b-tab-item label="Advanced 🆕">
        <VideoGrid :videos="advanced" />
      </b-tab-item>
    </b-tabs>

    <p
      class="is-size-4	 has-text-centered has-text-grey"
      v-if="activeTab == null"
    >
      Please select a lesson level
    </p>
  </div>
</template>

<script>
import { LESSON_LEVEL } from "@/constants";
import allLessons from "@/data/chess-lessons.json";
import VideoGrid from "@/components/lessons/VideoGrid";

export default {
  name: "Lessons",
  components: {
    VideoGrid,
  },
  data() {
    return {
      activeTab: null,
      beginner: [],
      rookie: [],
      intermediate: [],
      advanced: [],
    };
  },
  created() {
    allLessons.forEach((l) => {
      if (l.level === LESSON_LEVEL.BEGINNER) {
        this.beginner.push(l);
      } else if (l.level === LESSON_LEVEL.ROOKIE) {
        this.rookie.push(l);
      } else if (l.level === LESSON_LEVEL.INTERMEDIATE) {
        this.intermediate.push(l);
      } else if (l.level === LESSON_LEVEL.ADVANCED) {
        this.advanced.push(l);
      }
    });
  },
};
</script>
<style scoped>
.b-tabs >>> .tab-content {
  padding-left: 0;
  padding-right: 0;
}
.b-tabs >>> li[role="tab"] {
  min-width: 150px;
}
.tab-description {
  font-size: 16px;
  text-align: left;
  margin-bottom: 24px;
}
</style>
